import { IconScissor } from 'components/Icon/IconScissor'
import { IMedicareCard } from 'models/User'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MedicareCardBack } from './MedicareCardBack'
import { MedicareCardFront } from './MedicareCardFront'

type MedicareCardPrintableProps = {
  beneficiaryCardData: IMedicareCard
  partAActive: boolean
  partBActive: boolean
  children?: React.ReactNode
}
export const MedicareCardPrintable = React.forwardRef<
  HTMLDivElement,
  MedicareCardPrintableProps
>((props, ref) => {
  const { beneficiaryCardData, ...otherCardFrontProps } = props
  const { t } = useTranslation('getMyMedicareCardPage')

  // TODO: verify logic for full name
  const fullName =
    `${beneficiaryCardData.firstName} ${beneficiaryCardData.lastName}`.toUpperCase()
  const p1 = t('printView.p1').replace('%s', fullName)

  return (
    <>
      <div className='printable' ref={ref}>
        <div className="my-c-medicare-card-printable ds-base">
          <h2 className="ds-text-heading--2xl my-u-mb--2 my-u-lg-mb--6">
            {t('printView.mainHeading')}
          </h2>
          <p>{p1}</p>
          <p>{t('printView.p2')}</p>
          <div className="my-c-medicare-card-printable-layout">
            <MedicareCardFront
              beneficiaryCardData={beneficiaryCardData}
              {...otherCardFrontProps}
            />
            <MedicareCardBack />
            <div className="my-c-medicare-card-printable-cut-line">
              <span>
                <i className="ds-u-color--base ds-u-margin-right--1">
                  <IconScissor />
                </i>
                {t('printView.cutLine')}
              </span>
            </div>
            <div className="my-c-medicare-card-printable-fold-line">
              <span>{t('printView.foldLine')}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
})
